import { services } from '../../mocks/services';
import { areas } from '../../mocks/areas';

export default function Footer() {
  const whatsappMessage = encodeURIComponent("Hi Sea Pearl Universal, I'd like to book a cleaning service | مرحباً، أود حجز خدمة تنظيف");
  const whatsappLink = `https://api.whatsapp.com/send?phone=96879964466&text=${whatsappMessage}`;

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="contact" className="bg-gradient-to-br from-[#29ABE2] to-[#8DC63F] text-white pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          <div>
            <img src="https://static.readdy.ai/image/badfdf0c5f2d8472e707f25057dbcc7e/68f87dba7a9fe8a8a1cc140352171a6b.jpeg" alt="Sea Pearl Universal" className="h-16 w-auto mb-4 bg-white rounded-lg p-2" />
            <p className="text-sm mb-4 text-white/90">Professional cleaning services in Muscat, Oman. Your trusted partner for a cleaner, healthier space.</p>
            <p className="text-sm mb-2 text-white/90" dir="rtl">خدمات تنظيف احترافية في مسقط، عمان. شريكك الموثوق لمساحة أنظف وأكثر صحة.</p>
          </div>

          <div>
            <h3 className="text-base font-semibold mb-4">Our Services | خدماتنا</h3>
            <ul className="space-y-2">
              {services.slice(0, 6).map((service) => (
                <li key={service.id}>
                  <button onClick={() => scrollToSection('services')} className="text-sm text-white/90 hover:text-white transition-colors cursor-pointer">
                    {service.titleEn}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-base font-semibold mb-4">Areas Served | المناطق</h3>
            <ul className="space-y-2">
              {areas.slice(0, 6).map((area, index) => (
                <li key={index}>
                  <button onClick={() => scrollToSection('areas')} className="text-sm text-white/90 hover:text-white transition-colors cursor-pointer">
                    {area.nameEn}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-base font-semibold mb-4">Contact Us | اتصل بنا</h3>
            <div className="space-y-3">
              <a href={whatsappLink} target="_blank" rel="noopener noreferrer" className="flex items-center text-sm text-white/90 hover:text-white transition-colors cursor-pointer">
                <i className="ri-whatsapp-line text-lg mr-2"></i>
                <span>+968 79964466</span>
              </a>
              <a href="tel:+96879964466" className="flex items-center text-sm text-white/90 hover:text-white transition-colors cursor-pointer">
                <i className="ri-phone-line text-lg mr-2"></i>
                <span>+968 79964466</span>
              </a>
              <a href="mailto:seapearluniver@gmail.com" className="flex items-center text-sm text-white/90 hover:text-white transition-colors cursor-pointer">
                <i className="ri-mail-line text-lg mr-2"></i>
                <span>seapearluniver@gmail.com</span>
              </a>
              <div className="flex items-start text-sm text-white/90">
                <i className="ri-map-pin-line text-lg mr-2 mt-0.5"></i>
                <span>Muscat, Sultanate of Oman<br />مسقط، سلطنة عمان</span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-white/20 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-sm text-white/90 mb-4 md:mb-0">
              © 2025 Sea Pearl Universal. All rights reserved. | جميع الحقوق محفوظة
            </p>
            <div className="flex space-x-4">
              <a href="https://www.facebook.com/p/Sea-pearl-universal-100071273705795/" target="_blank" rel="noopener noreferrer" className="w-9 h-9 flex items-center justify-center bg-white/10 rounded-full hover:bg-white/20 transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a href="https://www.instagram.com/seapearluniversal?igsh=cnc0eWVpZWs0cjV3" target="_blank" rel="noopener noreferrer" className="w-9 h-9 flex items-center justify-center bg-white/10 rounded-full hover:bg-white/20 transition-colors cursor-pointer">
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a href="https://share.google/ks94C7FLV1y9zt0Ld" target="_blank" rel="noopener noreferrer" className="w-9 h-9 flex items-center justify-center bg-white/10 rounded-full hover:bg-white/20 transition-colors cursor-pointer">
                <i className="ri-google-fill text-lg"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}